import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
/* src/app/page.admin/view.scss: no such file or directory */`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public category: string = '';
    public main: string = '';
    public sub: string = '';
    public id: string = '';
    public menu: string = '';

    private routerSub: any;

    public categories: any[] = [
        {
            key: 'invest',
            title: '투자관리',
            description: '조합 결성·운용·해산, 투자기업, 조합원 관리',
            icon: 'chart',
            color: 'blue'
        },
        /*{
            key: 'support',
            title: '지원사업',
            description: '지원사업 관리 및 운영',
            icon: 'clipboard',
            color: 'emerald'
        },*/
        {
            key: 'system',
            title: '관리시스템',
            description: '내부 결재 및 시스템 관리',
            icon: 'cog',
            color: 'violet'
        }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(["admin", "super_admin"], "/");

        // 구독을 리다이렉트보다 먼저 등록 — service.href()로 인한 NavigationEnd를 놓치지 않도록
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                this.updateSegments();
                await this.service.render();
            }
        });

        this.updateSegments();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private updateSegments() {
        this.category = WizRoute.segment.category || '';
        this.main = WizRoute.segment.main || '';
        this.sub = WizRoute.segment.sub || '';
        this.id = WizRoute.segment.id || '';
        this.menu = WizRoute.segment.menu || '';

        if (!this.category) {
            // 리다이렉트와 동시에 로컬 상태도 즉시 기본값으로 설정 —
            // NavigationEnd가 늦게 도착하거나 누락되더라도 *ngIf가 즉시 평가되어
            // 대시보드가 첫 진입 시에도 바로 마운트되도록 보장
            this.category = 'invest';
            this.main = 'dashboard';
            this.service.href('/admin/invest/dashboard');
            return;
        }

        if (this.category && !this.main) {
            this.main = 'dashboard';
            this.service.href(`/admin/${this.category}/dashboard`);
        }
    }

    public event: any = {
        fund_item: {
            update: async (code, data) => {
                if (code == 201) {
                    location.href = `/admin/invest/fund/${this.sub}/${data}`;
                    return;
                } else if (code == 200) {
                    this.service.alert.success("저장되었습니다.");
                } else {
                    this.service.alert.error("오류가 발생했습니다.");
                }
            }
        }
    }
}

export default PageAdminComponent;